// extracted by mini-css-extract-plugin
export default {"accessRightIndicator":"institutionTeamList_accessRightIndicator__pe5jG","cardSpacing":"institutionTeamList_cardSpacing__J39XV"};